import { PriceZoneGateway } from '@price-card/gateways/price-zone.gateway';
import { PriceZone } from '@price-card/models/price-zone.model';
import { formatGetHeaders } from '@configurations/api-configuration';
import { environment } from '../../../../../environments/environment';

export class ApiPriceZoneGateway implements PriceZoneGateway {
  private readonly priceZoneApi = `${environment.backend_url}/api/v1/price-card/zone`;
  async retrieveAll(): Promise<PriceZone[]> {
    try {
      const response = await fetch(`${this.priceZoneApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving regions: ' + error);
    }
  }
}
